import styled from 'styled-components';

export const TechnicalTemplateStyled = styled.div`
  & .section-title {
    margin-bottom: 20px;
  }
  @media (max-width: 480px) {
    & .templateInfo {
      flex-direction: row;
    }
  }
`;
